/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { useTracker } from '../../../context/hooks';
import { removeAttachedContent } from '../data/attachedContent/thunks';
import { fetchTopics } from '../data/topics/thunks';
import { useDispatch } from '../store';
import { ThingsPeopleCover } from './ThingsPeopleCover';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AttachedState = ({
  attachedCluster
}) => {
  const dispatch = useDispatch();
  const {
    track
  } = useTracker();
  const {
    attachedContentId,
    clusterPhrase,
    subtopicPhrase,
    clusterId
  } = attachedCluster;
  useEffect(() => {
    dispatch(fetchTopics({
      clusterId
    }));
  }, [clusterId, dispatch]);
  const handleCloseClick = () => {
    track('clickedDetachTopic');
    if (attachedContentId) {
      dispatch(removeAttachedContent({
        attachedContentId
      }));
    }
  };
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "topic-editor-attached-state",
    margin: "600",
    as: "section",
    children: [/*#__PURE__*/_jsx(H7, {
      marginBlock: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.attachedState.topicLabel"
      })
    }), /*#__PURE__*/_jsx(Tag, {
      closeable: true,
      onCloseClick: handleCloseClick,
      use: "default",
      children: clusterPhrase
    }), subtopicPhrase && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(H7, {
        marginBlock: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "xray-recommendation-lib.seo.topicEditor.attachedState.subtopicLabel"
        })
      }), /*#__PURE__*/_jsx(Tag, {
        closeable: true,
        onCloseClick: handleCloseClick,
        use: "default",
        children: subtopicPhrase
      })]
    }), /*#__PURE__*/_jsx(ThingsPeopleCover, {
      phrase: subtopicPhrase || clusterPhrase
    })]
  });
};